const APIRoot = process.env.REACT_APP_API_ROOT;
const apiKey = process.env.REACT_APP_API_KEY;
const refreshTokenUrl = process.env.REACT_APP_REFRESH_TOKEN_API_ROOT + apiKey;

const TokenExchangeUrl = process.env.REACT_APP_REFRESH_TOKEN_API_ROOT + apiKey;

const content_admin = "content-admin";

export async function refreshToken() {
  const refreshToken = sessionStorage.getItem("refreshToken");
  if (Boolean(refreshToken)) {
    return fetch(refreshTokenUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        refresh_token: refreshToken,
        grant_type: "refresh_token"
      })
    })
      .then(response => response.json())
      .then(responseData => {
        if (responseData.id_token && responseData.refresh_token) {
          sessionStorage.setItem("refreshToken", responseData.refresh_token);
          sessionStorage.setItem("idToken", responseData.id_token);
        }
      });
  }
}

export {
  apiKey,
  APIRoot,
  TokenExchangeUrl,
  content_admin
  //refreshToken
};
